import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {};
export type CreateAdminResponse = {
  data: {
    id: number;
  };
};

export const useCreateAdmin = createMutation<
  CreateAdminResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/admins',
      method: 'POST',
      data: {},
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
